import "./notifications.scss";
import {
    type FC,
    useEffect,
    useRef,
    useState,
} from "react";
import { useShopfrontDispatch, useShopfrontSelector } from "../../../_Bootstrap/hooks";
import { LAYOUT_NOTIFICATIONS_TOGGLE } from "../../../Actions/General/LayoutActions";
import { fireEventType } from "../../../Utilities/Generic/ActionsHelper";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

export const NotificationIcon: FC = () => {
    const prevCountRef = useRef(0);
    const timeoutRef = useRef<null | ReturnType<typeof setTimeout>>(null);

    const dispatch = useShopfrontDispatch();

    const unreadCount = useShopfrontSelector(state => {
        let count = 0;

        for(const notification of state.notifications.notifications) {
            if(notification.deleted) {
                continue;
            }

            if(notification.readAt === null) {
                count++;
            }
        }

        return count;
    });

    const [ shaking, setShaking ] = useState(false);

    useEffect(() => {
        if(prevCountRef.current === unreadCount) {
            return;
        }

        prevCountRef.current = unreadCount;

        if(unreadCount <= 0) {
            return;
        }

        setShaking(true);

        const timeout = setTimeout(() => {
            setShaking(false);
        }, 3000);

        timeoutRef.current = timeout;

        return () => {
            clearTimeout(timeout);
        };
    }, [ unreadCount ]);

    let counter;

    if(unreadCount !== 0) {
        counter = <div className="notification-icon-indicator" />;
    }

    const classes: Array<string> = [];

    if(shaking) {
        classes.push("icon-shake");
    }

    return (
        <div
            className="header-item notification-bell"
            data-testid="sh-notifications"
            onClick={() => {
                dispatch(fireEventType(LAYOUT_NOTIFICATIONS_TOGGLE));
            }}
        >
            <div
                id="notification-icon"
                className={classes.join(" ")}
                data-testid="notification-bell"
            >
                <FontAwesomeLight icon="bell" />
                {counter}
            </div>
        </div>
    );
};
